import { digitGroup, commonDate } from 'src/helpers'
import endpoint from 'src/store/modules/endpoint'
import { businessGrade, submissionStatus } from 'src/vars'

function verifyCheck (val) {
  return val !== null && val !== undefined
}

export const tableCustomerMain = {
  showTable: true,
  exportApi: endpoint.state.customer,
  tableApi: endpoint.state.customer,
  rows: [],
  filterResponse: {},
  columnsObj: {
    name: {
      label: 'Nama Customer',
      name: 'name',
      field: row => {
        const badge = `<div class="custom-badge-square custom-badge-blue dense">
          <strong>Baru</strong>
        </div>`

        return `<a
          id="customerDetail-${row.id}"
          router-push="${
            encodeURIComponent(
              JSON.stringify({
                name: 'customer-detail',
                params: {
                  action: 'preview',
                  id: row.id,
                  isVerified: row.type === 'BUSINESS' ? verifyCheck(row.company?.is_verified) : verifyCheck(row?.verified_at),
                  type: row.type,
                  companyId: row?.company?.id
                }
              })
            )
          }"
          class="text-no-wrap"
        >
          <span>${row?.name || ''}</span>
          ${row?.is_new_customer ? badge : ''}
        </a>`
      },
      sortable: true,
      align: 'left',
      rowClass: 'td-width-small vertical-middle'
    },

    companyName: {
      label: 'Nama Perusahaan',
      name: 'companyName',
      field: row => {
        let nameLabel

        if (row.type === 'BUSINESS') {
          nameLabel = {
            PROJECT_OWNER: 'Pemilik Proyek',
            ARCHITECT: 'Arsitek',
            DEVELOPER: 'Developer',
            CONTRACTOR: 'Kontraktor',
            OTHER: 'Lainnya'
          }[row.company?.type] || '-'
        } else {
          nameLabel = 'Retail'
        }

        const companyLabel = `<div class="text-grey-6">${nameLabel}</div>`

        let companyName = row?.company?.company_type + ' ' || ''
        companyName += row?.company?.name

        const company = `<div>${companyName}</div><div>${companyLabel}</div>`
        return row?.company
          ? company
          : '-'
      },
      sortable: true,
      align: 'left'
    },

    type: {
      label: 'Jenis Akun',
      name: 'type',
      field: (row) => {
        return {
          BUSINESS: 'Bisnis',
          RETAIL: 'Retail'
        }[row.type] || '-'
      },
      sortable: true,
      align: 'left',
      rowClass: 'vertical-middle'
    },

    email: {
      label: 'Email & No. Telepon',
      name: 'email',
      field: (row) => {
        const phone = row.phone ? `<a id="phone-${row.id}" href="tel: ${row.phone || '-'}">${row.phone}</a>` : '-'
        return `<div class="q-mb-sm"><a id="email-${row.id}" href="mailto: ${row.email}">${row.email || '-'}</a></div>
        <div>${phone}</div>`
      },
      sortable: true,
      align: 'left',
      rowClass: 'vertical-middle'
    },

    eventTracker: {
      name: 'event_tracker',
      field: row => {
        const tracker = {
          CMS: ['CMS', 'custom-badge-purple', '16x16-users.svg', 'color-filter-purple'],
          ECOM: ['Website', 'custom-badge-green', '16x16-laptop.svg', 'color-filter-primary']
        }[row?.event_tracker] || [row?.event_tracker, 'custom-badge-green', '16x16-document.svg', 'color-filter-primary']
        return row?.event_tracker?.length
          ? `<div class="custom-badge-square ${tracker[1]} dense flex items-center gap-2">
              <img
                src="${require('src/assets/images/icons/' + tracker[2])}"
                alt=""
                class="${tracker[3]}"
                width="12"
              >
              <strong class="text-uppercase">
                ${tracker[0]}
              </strong>
            </div>`
          : '-'
      },
      label: 'Tracker',
      sortable: true,
      align: 'left',
      rowClass: 'vertical-middle'
    },

    createdAt: {
      name: 'created_at',
      field: 'created_at',
      label: 'Tanggal Daftar',
      sortable: true,
      align: 'left',
      commonDate: true,
      rowClass: 'vertical-middle'
    },

    paylater: {
      name: 'paylater',
      field: (row) => {
        const paylater = row.paylater
          ? row.paylater.map(item => {
            return item
              ? `<div role="alert" class="${businessGrade[item]?.badgeClass}">
                  ${businessGrade[item]?.name}
                </div>`
              : ''
          })
          : []

        return `<div class="flex gap-3">
          ${paylater.join('')}
        </div>`
      },
      label: 'BNPL',
      sortable: true,
      align: 'left',
      rowClass: 'text-no-wrap vertical-middle'
    },

    referalCode: {
      name: 'referal_code',
      field: row => {
        if (row.type === 'BUSINESS') {
          return row.company?.referal_code || '-'
        }

        return row?.referal_code || '-'
      },
      label: 'Sales Referal',
      sortable: true,
      align: 'left',
      rowClass: 'vertical-middle'
    }
  },

  columns: [],
  selectedRow: []
}

export const tableCustomerAddress = {
  columns: [
    {
      name: 'label',
      field: row => {
        return `<div class="ellipsis-2-lines" style="min-width: 150px;">${row.label}</div>`
      },
      label: 'Label',
      sortable: false,
      align: 'left'
    },
    {
      name: 'recipient_name',
      field: row => {
        return row.name1 || '-'
      },
      label: 'Penerima',
      sortable: false,
      align: 'left'
    },
    {
      name: 'address',
      field: row => {
        return `
          <div class="ellipsis-3-lines" style="max-width: 300px;">
            ${row.address?.startsWith('http') ? `<a href="${row.address}" target="_blank" rel="noopener noreferrer" class="text-primary">${row.address}</a>` : row.address || '-'}
          </div>
        `
      },
      label: 'Alamat Lengkap',
      sortable: false,
      align: 'left'
    },
    {
      name: 'province_name',
      field: row => {
        return row.province_name || '-'
      },
      label: 'Provinsi',
      sortable: false,
      align: 'left'
    },
    {
      name: 'city_name',
      field: row => {
        return row.city_name || '-'
      },
      label: 'Kota/Kabupaten',
      sortable: false,
      align: 'left'
    },
    {
      name: 'district_name',
      field: row => {
        return row.district_name || '-'
      },
      label: 'Kecamatan',
      sortable: false,
      align: 'left'
    },
    {
      name: 'zipcode',
      field: row => {
        return row.zipcode || '-'
      },
      label: 'Kode Pos',
      sortable: false,
      align: 'left'
    }
  ]
}

export const tableCustomerPic = {
  columns: [
    {
      name: 'name',
      field: row => row.name || '-',
      label: 'Nama',
      sortable: true,
      align: 'left',
      rowClass: 'vertical-middle'
    },
    {
      name: 'position',
      field: row => row.position || '-',
      label: 'Jabatan',
      sortable: true,
      align: 'left',
      rowClass: 'vertical-middle'
    },
    {
      name: 'nik',
      label: 'KTP',
      field: (row) => {
        const imageKtp = row.image_ktp
          ? `<a
            href="javascript: void(0)"
            class="q-mt-xs text-primary cursor-pointer open-ktp"
            data-ktp="${row.image_ktp}"
          >
            Lihat Lampiran
          </a>`
          : ''
        return `
          <div class="column">
            <div class="text-weight-medium">
              ${row?.nik || '-'}
            </div>
            ${imageKtp}
          </div>
        `
      },
      sortable: true,
      align: 'left',
      rowClass: 'vertical-middle'
    },
    {
      name: 'email',
      label: 'Email & No. Telepon',
      field: (row) => `
        <div class="column">
          <span class="text-weight-medium">
            ${row?.email || '-'}
          </span>
          <span class="q-mt-xs">${row?.phone || '-'}</span>
        </div>
      `,
      sortable: true,
      align: 'left',
      rowClass: 'vertical-middle'
    },
    {
      name: 'status',
      field: (row) => {
        // ecommerce user requirement
        if (row.status === 'ACTIVE' && !row.verified_at) {
          return '<div class="custom-badge-purple dense">Belum Dikonfirmasi</div>'
        }

        return (
          {
            UNVERIFIED:
              '<div class="custom-badge-purple dense">Belum Dikonfirmasi</div>',
            ACTIVE: '<div class="custom-badge-green dense">Aktif</div>',
            NOT_ACTIVE: '<div class="custom-badge-red dense">Nonaktif</div>'
          }[row.status] || '-'
        )
      },
      label: 'Status Pengguna',
      sortable: true,
      align: 'left',
      rowClass: 'vertical-middle'
    }
  ]
}

export const tableCustomerPicAdd = {
  columns: [
    {
      name: 'name',
      field: 'name',
      label: 'Nama Pengguna',
      align: 'left'
    },
    {
      name: 'position',
      field: 'position',
      label: 'Jabatan',
      align: 'left'
    },
    {
      name: 'nik',
      field: 'nik',
      label: 'No. KTP & Foto KTP',
      align: 'left'
    },
    {
      name: 'email',
      field: 'email',
      label: 'Email',
      align: 'left'
    },
    {
      name: 'phone',
      field: 'phone',
      label: 'No. Telepon',
      align: 'left'
    },
    {
      name: 'action',
      field: 'action',
      label: '',
      align: 'center'
    }
  ]
}

export const tableCustomerSubmission = {
  columns: [
    {
      name: 'current_grade_code',
      field: (row) => {
        const currentGrade = businessGrade[row.current_grade_code] || {
          name: 'Bisnis',
          badgeClass: 'custom-badge-square custom-badge-white'
        }

        return `
          <div role="alert" class="${currentGrade.badgeClass}">
            ${currentGrade.name}
          </div>
        `
      },
      label: 'Grade Awal',
      align: 'left',
      sortable: false,
      rowClass: 'vertical-middle'
    },
    {
      name: 'submission_type',
      field: (row) => {
        return {
          UPGRADE: 'Pengajuan BNPL',
          UPLIMIT: 'Kenaikan Limit'
        }[row.submission_type]
      },
      label: 'Jenis Pengajuan',
      align: 'left',
      sortable: false,
      rowClass: 'vertical-middle'
    },
    {
      name: 'requested_grade_code',
      field: (row) => {
        const requestedGrade = businessGrade[row.requested_grade_code] || {
          name: 'Bisnis',
          badgeClass: 'custom-badge-square custom-badge-white'
        }

        if (row.submission_type === 'UPLIMIT') {
          return ''
        }

        return `
          <div role="alert" class="${requestedGrade.badgeClass}">
            ${requestedGrade.name}
          </div>
        `
      },
      label: 'Grade Tujuan',
      align: 'left',
      sortable: false,
      rowClass: 'vertical-middle'
    },
    {
      name: 'created_by_name',
      field: (row) => {
        const originBadge = {
          ECOM: ['custom-badge-green', 'color-filter-primary', 'Customer'],
          PMP: ['custom-badge-green', 'color-filter-primary', 'Customer'],
          CMS: ['custom-badge-purple', 'color-filter-purple', 'CMS']
        }[row.origin || 'CMS']

        return `
          <div role="alert" class="${originBadge[0]} dense">
            <img
              src="${require('src/assets/images/icons/12x12-laptop.svg')}"
              class="${originBadge[1]}"
              alt="icon"
            >
            <span class="q-ml-xs">${originBadge[2]}</span>
          </div>
          ${
            row.created_by_name || row.origin === 'CMS'
              ? `<div class="text-base text-capitalize">
                  ${row.created_by_name}
                </div>`
              : ''
          }
        `
      },
      label: 'Pemohon',
      align: 'left',
      sortable: false,
      rowClass: 'vertical-middle'
    },
    {
      name: 'limit_requested',
      field: (row) => Number(row.limit_requested) ? 'Rp ' + digitGroup(row.limit_requested) : '-',
      label: 'Limit Diajukan',
      align: 'right',
      rowClass: 'text-no-wrap text-right vertical-middle',
      sortable: false
    },
    {
      name: 'limit_approved',
      field: (row) => row.limit_approved ? 'Rp ' + digitGroup(row.limit_approved) : '-',
      label: 'Limit Diberikan',
      align: 'right',
      rowClass: 'text-no-wrap text-right vertical-middle',
      sortable: false
    },
    {
      name: 'created_at',
      field: 'created_at',
      label: 'Tanggal Diajukan',
      align: 'left',
      commonDate: true,
      sortable: false,
      rowClass: 'vertical-middle'
    },
    {
      name: 'verified_at',
      field: 'verified_at',
      label: 'Tanggal Diverifikasi',
      align: 'left',
      commonDate: true,
      sortable: false,
      rowClass: 'vertical-middle'
    },
    {
      name: 'status',
      field: (row) => {
        const badgeInfo = {
          APPROVED: ['custom-badge-green', 'Disetujui'],
          PROCESSED: ['custom-badge-yellow', 'Diproses'],
          REJECTED: ['custom-badge-red', 'Ditolak']
        }[row.status]

        return `
          <div role="alert" class="${badgeInfo[0]} dense">
            ${badgeInfo[1]}
          </div>
        `
      },
      label: 'Status',
      align: 'left',
      sortable: false,
      rowClass: 'vertical-middle'
    }
  ]
}

// -------------
// SUBMISSION
// -------------
const endpointCustSubmission = '/submission/bnpl/external'

// KOINWORKS
export const tableCustSubmissionKoinworks = {
  api: endpointCustSubmission + '/koinworks',
  columns: [
    {
      name: 'invitationAt',
      label: 'Tanggal Diundang',
      field: 'invitationAt',
      align: 'left',
      rowClass: 'text-left',
      commonDate: true
    },
    {
      name: 'status',
      label: 'Status',
      field: row => {
        const currentGrade = submissionStatus.bnpl[row.status] || {
          name: '-',
          badgeClass: 'custom-badge-square'
        }

        return `
          <div role="alert" class="${currentGrade.badgeClass}">
            ${currentGrade.name}
          </div>
          <div class="text-no-wrap text-grey-7">
            ${
              (row.statusAt && 'Diperbaharui ' + commonDate({
                date: row.statusAt,
                useDayName: false,
                useTime: false
              })) || '-'
            }
          </div>
        `
      },
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    },
    {
      name: 'information',
      label: 'Keterangan Detail Proses',
      field: row => {
        return `<div
          role="alert"
          class="custom-badge-square ellipsis"
          style="max-width: 250px; justify-content: flex-start;"
        >
          ${row.information}
        </div>`
      },
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    }
  ]
}

// CREDILINQ
export const tableCustSubmissionCredilinq = {
  api: endpointCustSubmission + '/credilinq',
  columns: [
    ...tableCustSubmissionKoinworks.columns
  ]
}

// PRODUCT SALES MANAGER
export const tableCustSubmissionSm = {
  columns: [
    {
      name: 'company_name',
      field: 'company_name',
      label: 'Nama Perusahaan',
      sortable: true,
      align: 'left',
      rowClass: 'text-primary text-weight-bold text-capitalize'
    },
    {
      name: 'current_grade_code',
      label: 'Grade Awal',
      field: (row) => {
        const currentGrade = businessGrade[row.current_grade_code] || {
          name: 'Bisnis',
          badgeClass: 'custom-badge-square custom-badge-white'
        }

        return `
          <div role="alert" class="${currentGrade.badgeClass}">
            ${currentGrade.name}
          </div>
        `
      }
    },
    {
      name: 'submission_type',
      field: row => {
        return {
          UPGRADE: 'Kenaikan Grade',
          TEMPO: 'Pengajuan Tempo',
          UPLIMIT: 'Kenaikan Limit',
          VERIFICATION: 'Verifikasi Akun Bisnis'
        }[row.submission_type] || row.submission_type
      },
      label: 'Jenis Pengajuan',
      sortable: true,
      align: 'left'
    },
    {
      name: 'requested_grade_code',
      label: 'Grade Tujuan',
      field: (row) => {
        const requestedGrade = businessGrade[row.requested_grade_code] || {
          name: 'Bisnis',
          badgeClass: 'custom-badge-square custom-badge-white'
        }

        if (row.submission_type === 'UPLIMIT') {
          return ''
        }

        return `
          <div role="alert" class="${requestedGrade.badgeClass}">
            ${requestedGrade.name}
          </div>
        `
      },
      align: 'left'
    },
    {
      name: 'limit_requested',
      field: 'limit_requested',
      label: 'Limit Diminta',
      sortable: true,
      align: 'right',
      inRupiah: true,
      rowClass: 'text-right'
    },
    {
      name: 'limit_approved',
      label: 'Limit Diberikan',
      field: 'limit_approved',
      sortable: true,
      align: 'right',
      inRupiah: true,
      rowClass: 'text-right'
    },
    {
      name: 'created_at',
      field: 'created_at',
      label: 'Tanggal Pengajuan',
      sortable: true,
      align: 'left',
      commonDate: true
    },
    {
      name: 'processed_at',
      label: 'Tanggal Diproses',
      field: 'processed_at',
      sortable: true,
      align: 'left',
      commonDate: true
    },
    {
      name: 'status',
      field: row => {
        const currentGrade = submissionStatus.jm[row.status] || {
          name: '-',
          badgeClass: 'custom-badge-square'
        }

        return `
          <div role="alert" class="${currentGrade.badgeClass}">
            ${currentGrade.name}
          </div>
        `
      },
      label: 'Status',
      sortable: true,
      align: 'left',
      rowClass: 'text-left'
    }
  ]
}

// FINANCE
export const tableCustSubmissionFat = {
  columns: tableCustSubmissionSm.columns
}

// SVP MARKETING
export const tableCustSubmissionSvp = {
  columns: tableCustSubmissionSm.columns
}
